import { UploadService } from './service';
import { UploadOption, UploadResult } from './model';

const uploadService = new UploadService();

export { uploadService, UploadOption, UploadResult };
